import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {startWith, map, tap} from 'rxjs/operators';
import { NormalizeStringService } from 'src/app/service/normalizeStrings/normalize-string.service';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-autocomplete-material',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent  implements OnInit, AfterViewInit {
 @Input() placeholder: string = "";

  // Ahora acepta tanto strings como objetos
  @Input() options: any[] = [];

  // Propiedad para especificar qué campo mostrar cuando es objeto
  @Input() displayProperty: string = ''; // ej: 'value_text'

  @Input() initialInputValue: string = "";
  @Input() addAlertIcon: boolean = false;
  @Input() addChevronDownIcon: boolean = false;
  // Ahora emite el objeto completo o el string
  @Output() optionSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output()  noMatchesFound  = new EventEmitter<any>();

  control = new FormControl(this.initialInputValue);
  filteredOptions: Observable<any[]>;

  @ViewChild('autoInput') autoInput: ElementRef;
  @ViewChild('autoInput', { read: MatAutocompleteTrigger }) trigger: MatAutocompleteTrigger;
  private isInitialized = false;
  constructor(
    private normalizeStringService: NormalizeStringService,
  ) { }

  ngOnInit() {}

  ngOnChanges() {
    this.isInitialized = false;
    this.control.setValue(this.initialInputValue);
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map(value => {
        if (this.isInitialized && typeof value === 'string' && value === '') {
          this.noMatchesFound.emit();
        };
        return this._filter(value || '')
      }),
      tap(filtered => {
        if (filtered.length === 0) {
          this.noMatchesFound.emit(this.control.value);
        }
      })
    );

    setTimeout(() => {
      this.isInitialized = true;
    }, 20);
  }

  ngAfterViewInit() {}

  private _filter(value: string): any[] {
    let filterValue = "";

    if (typeof value === 'string') {
      filterValue = this.normalizeStringService.normalizeValue(value);
    }
    else if (this.displayProperty && value[this.displayProperty]) {
      filterValue = this.normalizeStringService.normalizeValue(value[this.displayProperty]);
    }

    return this.options.filter(option => {
      if (typeof option === 'string') {
        return this.normalizeStringService.normalizeValue(option).includes(filterValue);
      }
      else if (this.displayProperty && option[this.displayProperty]) {
        return this.normalizeStringService.normalizeValue(option[this.displayProperty]).includes(filterValue);
      }
      return false;
    });
  }

  // Método helper para obtener el texto a mostrar
  getDisplayValue(option: any): string {
    if (typeof option === 'string') {
      return option;
    }
    return this.displayProperty ? option[this.displayProperty] : option;
  }

  onOptionSelected(event: any) {
    // Emite el objeto completo o el string
    const selectedValue = event.option.value;
    this.optionSelected.emit(selectedValue);
  }

  onClearInput() {
    this.control.reset();
    this.optionSelected.emit(null);
  }

  openAutocomplete() {
    this.autoInput.nativeElement.focus();
    this.trigger.openPanel();
  }

  displayFn(option: any): string {
    if (!option) return '';
    if (typeof option === 'string') {
      return option;
    }
    return this.displayProperty ? option[this.displayProperty] : option;
  }
}
